import { setupLinkListeners } from "./utils/links";

export function start() {
  setupLinkListeners();
}
